<div class="dialog small">
  <div class="search-list-dialog-close" [mat-dialog-close]="false"></div>
  <h3 class="dialog-title">
    {{ 'dialogs.technical-work-dialog.update-in-progress' | translate }}
  </h3>
  <div class="dialog-body">
    <div class="dialog-subtitle" [innerHTML]="'dialogs.technical-work-dialog.adding-new-features' | translate"></div>
    <ng-lottie class="mt-4 mb-4" [options]="options"></ng-lottie>
  </div>

  <div class="dialog-actions">
    <button class="btn btn-stroked" [mat-dialog-close]="false">
      {{ 'shared.close' | translate }}
    </button>
    <button class="btn btn-primary" (click)="reloadPage()">
      {{ 'shared.reload' | translate }}
    </button>
  </div>
</div>
